import { getAppData } from 'larasnap';
import boot from './bootstrap';
import './js/loaders/vue';
import './js/loaders/jquery_plugins';
import './vue/body_portal';

window.log = (...args) => console.log(...args);

boot(getAppData());

/* 
--------------- Larasnap Dependencies ---------------
Eventually once this becomes an actual package these 
will need to be listed as dependencies

moment
momentDurationFormatSetup
load-google-maps-api
jQuery
lodash
vue
vuex
sweetalert2
...?
*/
